<app-base-action-modal
  modalTitle="Add Additional Contact"
  i18n-modalTitle
  primaryLabel="Add Contact"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (closeClicked)="cancel()"
  (secondaryClicked)="cancel()"
  (primaryClicked)="addContact()">
  <div class="d-flex flex-column" [style.gap.rem]="2" [formGroup]="formGroup">
    <div class="d-flex gap-2 align-items-center">
      <app-checkbox-input formControlName="hasSigningAuthority" [controlId]="'hasSigningAuthority'" />
      <app-form-option-label [labelFor]="'hasSigningAuthority'" i18n>Has Signing Authority</app-form-option-label>
    </div>
    <div class="d-flex flex-column gap-4">
      <div class="form-grid">
        <div class="d-flex flex-column gap-1">
          <label class="form-input-label" [for]="'firstName'" i18n>First Name</label>
          <app-text-input
            formControlName="firstName"
            [controlId]="'firstName'"
            [error]="formSubmitted && formGroup.controls.firstName.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.firstName.invalid"
            [errors]="formGroup.controls.firstName.errors"
            [customErrorMessages]="customErrorMessages.firstName" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label class="form-input-label" [for]="'lastName'" i18n>Last Name</label>
          <app-text-input
            formControlName="lastName"
            [controlId]="'lastName'"
            [error]="formSubmitted && formGroup.controls.lastName.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.lastName.invalid"
            [errors]="formGroup.controls.lastName.errors"
            [customErrorMessages]="customErrorMessages.lastName" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label class="form-input-label" [for]="'jobTitle'" i18n>Job Title</label>
          <app-text-input
            formControlName="jobTitle"
            [controlId]="'jobTitle'"
            [error]="formSubmitted && formGroup.controls.jobTitle.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.jobTitle.invalid"
            [errors]="formGroup.controls.jobTitle.errors"
            [customErrorMessages]="customErrorMessages.jobTitle" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label [for]="'email'" class="form-input-label" i18n>Email Address</label>
          <app-email-input
            formControlName="email"
            [controlId]="'email'"
            [error]="formSubmitted && formGroup.controls.email.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.email.invalid"
            [customErrorMessages]="customErrorMessages.email"
            [errors]="formGroup.controls.email.errors" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label [for]="'phoneNumber'" class="form-input-label" i18n>Phone Number</label>
          <app-phone-country-code
            [formGroup]="formGroup"
            [countryCodes]="countryCodeDropdowns$ | async"
            [controlId]="'phoneNumber'"
            [phoneNumberControlName]="'phoneNumber'"
            [countryCodeControlName]="'phoneNumberCountryCode'" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.phoneNumber.invalid"
            [errors]="formGroup.controls.phoneNumber.errors"
            [customErrorMessages]="customErrorMessages.phoneNumber" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label class="form-input-label" [for]="'contactTopic'" i18n>Contact Topic</label>
          <app-masked-text-input
            formControlName="contactTopic"
            [maskOptions]="maskitoOptions.contactTopic"
            [controlId]="'contactTopic'"
            [error]="formSubmitted && formGroup.controls.contactTopic.invalid" />
          <div class="d-flex flex-row gap-2 justify-content-end">
            <app-form-error
              class="flex-grow-1"
              *ngIf="formSubmitted && formGroup.controls.contactTopic.invalid"
              [errors]="formGroup.controls.contactTopic.errors"
              [customErrorMessages]="customErrorMessages.contactTopic" />
            <div class="form-input-hint">{{ formGroup.controls.contactTopic.value?.length ?? 0 }}/40</div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="formGroup.controls.hasSigningAuthority.value">
        <hr class="m-0" />

        <app-international-address-form-grid
          controlIdPrefix="additionalContactAddress"
          [canadaOnly]="true"
          [form]="formGroup.controls.address"
          [formSubmitted]="formSubmitted" />
      </ng-container>
    </div>
  </div>
</app-base-action-modal>
